
import { Watch, Mixins, Component, ProvideReactive } from "vue-property-decorator";
import TwoHourList from "./components/TwoHourList.vue";
import WeightManagement from "./components/WeightManagement.vue";


@Component({ name: 'two-hour-index',
  inject: [],
  components: { TwoHourList, WeightManagement }
})
export default class TwoHourIndex extends Mixins() {
    @ProvideReactive() currentTab = "1";
}

